import { getHistory } from "./getHistory";
import { ActivityStore } from "./ActivityStore";
import { GlobalStore } from "../global/GlobalStore";

export const attachReactions = (): void => {
  /* This reaction holds back fetching history until we have tokens
   *  We require the tokens decimals in order to format values and we get this from /tokens
   *  we may want to add a function for getting token decimals from the smart contract as a extra fail safe
   * */

  // ActivityStore reaction
  ActivityStore.createReaction(
    store => store.tokens,
    tokens => {
      if (tokens) {
        const address = GlobalStore.getRawState().address;
        const TODAY_TIMESTAMP = new Date().getTime() * 1e6;
        if (address) {
          void getHistory.run({
            address: address as `0x${string}`,
            tokenMetadata: tokens,
            timestamp: TODAY_TIMESTAMP, // Timestamp needs to be provided in nanoseconds due to DB getTime returns milli then we convert to nano by multiplying
            previousResult: undefined,
          });
        }
      }
    }
  );
};
